import React from 'react'
import PropTypes from 'prop-types'
import InputContainer from '../components/InputContainer'

const DateInput = props => <InputContainer {...props} type="date" />

DateInput.propTypes = {
  suffix: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  startDate: PropTypes.any,
  focusedLabel: PropTypes.bool
}
DateInput.defaultProps = {
  label: '',
  suffix: '',
  type: 'date',
  value: '',
  error: '',
  onFocus: e => {},
  onBlur: e => {},
  placeholder: '',
  defaultValue: null
}

export default DateInput
